import { FC } from 'react';
import { styled } from "@mui/system";
import { values } from 'lodash';


const Select = styled('select')`
  width: 100%;
  height: 3em;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 12px;
`;

interface IOption {
  label: string;
  key: any;
}

export interface ISelectProps extends Omit<React.InputHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  validation?: 'error' | undefined;
  validationMsg?: string;
  values: IOption[];
}

export const Dropdown: FC<ISelectProps> = ({ onChange, placeholder, value, values, validation, validationMsg, name, ...rest }) => {
  let classes = "cb-input cb-btn-input cb-clear-input cb-value-ci";
  if (validation === 'error') {
    classes += ' cb-validation-error';
  }

  return <>
    <div className={classes}>
      <div className="cb-validation-label-input">
        <Select onChange={onChange} {...rest} name={name} value={value || ''}>
          <option value=''>{placeholder || 'Choose an Option'}</option>
          {values.map((item, i) => {
            return <option key={`dropdown-option-${name}-${i}`} value={item.key}>{item.label}</option>;
          })}
        </Select>
      </div>
      {validation === 'error' &&
        <i className="cb-validation-icon cb-icon cb-exclamation" aria-hidden="true"></i>
      }
    </div>
    {validation === 'error' &&
      <p className="cb-input-helper cb-validation-error">{validationMsg || ''}</p>
    }
  </>;
};